import { FirebaseAuthErrorCode } from '@griply/types';
import { ErrorLevel, getAuthErrorCode } from '@griply/utils';
import { getErrorReporter } from 'shared/services/error-tracking';

import { initAuth } from './authentication';

// Offline: the next focus retries. The other two are the codes on which the web SDK itself signs out.
const expectedReloadErrorCodes: string[] = [
  FirebaseAuthErrorCode.NetworkRequestFailed,
  FirebaseAuthErrorCode.UserTokenExpired,
  FirebaseAuthErrorCode.UserDisabled,
];

let initialized = false;
let isReloading = false;

const refresh = async () => {
  if (isReloading) {
    return;
  }
  isReloading = true;
  try {
    const auth = await initAuth();
    if (!auth.currentUser) {
      return;
    }
    await auth.currentUser.reload();
  } catch (error) {
    if (expectedReloadErrorCodes.includes(getAuthErrorCode(error))) {
      return;
    }
    getErrorReporter().captureException(error, {
      tags: { source: 'auth-token-refresh-on-focus' },
      level: ErrorLevel.Warning,
    });
  } finally {
    isReloading = false;
  }
};

const handleVisibilityChange = () => {
  if (document.visibilityState !== 'visible') {
    return;
  }
  refresh();
};

export const initAuthTokenRefreshOnFocus = () => {
  if (initialized) {
    return;
  }
  initialized = true;

  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('focus', refresh);

  refresh();
};

export const __resetAuthTokenRefreshOnFocusForTests = () => {
  initialized = false;
  isReloading = false;
};
